import { Injectable } from '@angular/core';
import { type PrimaryLayoutComponent } from './primary-layout.component';

@Injectable({
  providedIn: 'root',
})
export class PrimaryLayoutService {
  #component: PrimaryLayoutComponent | null = null;

  registerComponent(component: PrimaryLayoutComponent): void {
    this.#component = component;
  }

  scrollTo(options?: ScrollToOptions): void {
    if (this.#component) {
      this.#component.scrollTo(options);
    }
  }
}
